var storeID;
// storeID = storeID.split('=')[1];
var storeReviews = ''
console.log(window.location.href.split("/").pop());
var storeLocationSearch = window.location.search;
var storeLocation = window.location.href.split("/").pop();
storeLocation = storeLocation.split("?")[0];
if(storeLocationSearch.includes("?id=")){
  console.log('true id');
  location.href = storeLocation
}

if (storeLocation == "walworth") { storeID = 6101 }
else if (storeLocation == "catford") { storeID = 6102 }
else if (storeLocation == "poplar") { storeID = 6103 }
else if (storeLocation == "clapham")  { storeID = 6104 }
else if (storeLocation == "peckham") { storeID = 6105 }
else if (storeLocation == "deptford") { storeID = 6106 }
else if (storeLocation == "burnt-oak") { storeID = 6107 }
else if (storeLocation == "fulham") { storeID = 6108 }
else if (storeLocation == "willesden") { storeID = 6109 }
else if (storeLocation == "tooting") { storeID = 6111 }
else if (storeLocation == "gillingham") { storeID = 6113 }
else if (storeLocation == "leyton") { storeID = 6114 }
else if (storeLocation == "dalston") { storeID = 6115 }
else if (storeLocation == "finsbury") { storeID = 6116 }
else if (storeLocation == "brighton") { storeID = 6117 }
else if (storeLocation == "hounslow") { storeID = 6119 }
else if (storeLocation == "sutton") { storeID = 6120 }
else if (storeLocation == "hammersmith") { storeID = 6121 }
else if (storeLocation == "slough") { storeID = 6122 }
else if (storeLocation == "barking") { storeID = 6123 }
else if (storeLocation == "surrey-quays") { storeID = 6124 }
else if (storeLocation == "streatham") { storeID = 6127 }
else if (storeLocation == "walthamstow") { storeID = 6128 }
else if (storeLocation == "bow") { storeID = 6130 }
else if (storeLocation == "clapton") { storeID = 6131 }
else if (storeLocation == "ilford") { storeID = 6132 }
else if (storeLocation == "paddington") { storeID = 6133 }
else if (storeLocation == "chalk-farm") { storeID = 6134 }
else if (storeLocation == "dartford") { storeID = 6196 }
else if (storeLocation == "birmingham-ethel-street") { storeID = 6201 }
else if (storeLocation == "walsall") { storeID = 6202 }
else if (storeLocation == "stretford") { storeID = 6205 }
else if (storeLocation == "bradford") { storeID = 6207 }
else if (storeLocation == "coventry-hales-street") { storeID = 6215 }
else if (storeLocation == "dudley") { storeID = 6220 }
else if (storeLocation == "liverpool") { storeID = 6230 }
else if (storeLocation == "blackpool") { storeID = 6240 }
else if (storeLocation == "edinburgh-lauriston-place") { storeID = 6301 }
else if (storeLocation == "govan") { storeID = 6302 }
else if (storeLocation == "dundee") { storeID = 6303 }
else if (storeLocation == "glasgow-bath-street") { storeID = 6304 }
else if (storeLocation == "newcastle-clayton-street") { storeID = 6305 }
else if (storeLocation == "welling") { storeID = 6307 }
else if (storeLocation == "blackburn") { storeID = 6309 }
else if (storeLocation == "partick") { storeID = 6310 }
else if (storeLocation == "dagenham") { storeID = 6311 }
else if (storeLocation == "hastings") { storeID = 6312 }
else if (storeLocation == "runcorn") { storeID = 6400 }
else if (storeLocation == "bootle") { storeID = 6401 }
else if (storeLocation == "kirkby") { storeID = 6402 }
else if (storeLocation == "clydebank") { storeID = 6403 }
else if (storeLocation == "rutherglen") { storeID = 6404 }
else if (storeLocation == "easterhouse") { storeID = 6405 }
else if (storeLocation == "greenock") { storeID = 6406 }
else if (storeLocation == "bolton-newport-street") { storeID = 6407 }
else if (storeLocation == "macclesfield") { storeID = 6408 }
else if (storeLocation == "salford") { storeID = 6409 }
else if (storeLocation == "stockport") { storeID = 6410 }
else if (storeLocation == "livingston") { storeID = 6411 }
else if (storeLocation == "wigan") { storeID = 6412 }
else if (storeLocation == "kirkcaldy") { storeID = 6413 }
if (storeLocation == "acocks-green") { storeID = 6414 }
else if (storeLocation == "acomb") { storeID = 6415 }
else if (storeLocation == "ashton-under-lyne") { storeID = 6416 }
else if (storeLocation == "barkingside") { storeID = 6417 }
else if (storeLocation == "barnsley") { storeID = 6418 }
else if (storeLocation == "bedford") { storeID = 6419 }
else if (storeLocation == "bletchley") { storeID = 6420 }
else if (storeLocation == "bolton-great-moor-street") { storeID = 6421 }
else if (storeLocation == "borehamwood") { storeID = 6422 }
else if (storeLocation == "bridgwater") { storeID = 6423 }
else if (storeLocation == "burnley") { storeID = 6424 }
else if (storeLocation == "burnt-oak-broadway") { storeID = 6425 }
else if (storeLocation == "burton-on-trent") { storeID = 6426 }
else if (storeLocation == "cambridge") { storeID = 6427 }
else if (storeLocation == "canning-town") { storeID = 6428 }
else if (storeLocation == "canterbury") { storeID = 6429 }
else if (storeLocation == "clacton-on-sea") { storeID = 6430 }
else if (storeLocation == "cumbernauld") { storeID = 6431 }
else if (storeLocation == "dover") { storeID = 6432 }
else if (storeLocation == "dunstable") { storeID = 6433 }
else if (storeLocation == "edgware") { storeID = 6434 }
else if (storeLocation == "enfield") { storeID = 6435 }
else if (storeLocation == "erdington") { storeID = 6436 }
else if (storeLocation == "golders-green") { storeID = 6437 }
else if (storeLocation == "grays") { storeID = 6438 }
else if (storeLocation == "halifax") { storeID = 6439 }
else if (storeLocation == "hamilton") { storeID = 6440 }
else if (storeLocation == "leeds-harehills") { storeID = 6441 }
else if (storeLocation == "harrow") { storeID = 6442 }
else if (storeLocation == "hatfield") { storeID = 6443 }
else if (storeLocation == "hayes-coldharbour-lane") { storeID = 6444 }
else if (storeLocation == "hemel-hempstead") { storeID = 6445 }
else if (storeLocation == "huddersfield") { storeID = 6446 }
else if (storeLocation == "huyton") { storeID = 6447 }
else if (storeLocation == "ipswich") { storeID = 6448 }
else if (storeLocation == "kidderminster") { storeID = 6449 }
else if (storeLocation == "kilburn-high-road") { storeID = 6450 }
else if (storeLocation == "kilburn-bridge") { storeID = 6451 }
else if (storeLocation == "kingstanding") { storeID = 6452 }
else if (storeLocation == "levenshulme") { storeID = 6453 }
else if (storeLocation == "maidstone") { storeID = 6454 }
else if (storeLocation == "mansfield") { storeID = 6455 }
else if (storeLocation == "newport") { storeID = 6457 }
else if (storeLocation == "norwich") { storeID = 6458 }
else if (storeLocation == "peterborough-lincoln-road") { storeID = 6459 }
else if (storeLocation == "ramsgate") { storeID = 6460 }
else if (storeLocation == "northampton-regent-square") { storeID = 6461 }
else if (storeLocation == "rochdale-baillie-street") { storeID = 6462 }
else if (storeLocation == "shawlands") { storeID = 6463 }
else if (storeLocation == "sheffield-king-street") { storeID = 6464 }
else if (storeLocation == "sittingbourne") { storeID = 6465 }
else if (storeLocation == "waltham-cross") { storeID = 6467 }
else if (storeLocation == "ward-end") { storeID = 6468 }
else if (storeLocation == "wellingborough") { storeID = 6469 }
else if (storeLocation == "widnes") { storeID = 6470 }
else if (storeLocation == "willesden-walm-lane") { storeID = 6471 }
else if (storeLocation == "wisbech") { storeID = 6472 }
else if (storeLocation == "woking") { storeID = 6473 }
else if (storeLocation == "wolverhampton-darlington-street") { storeID = 6474 }
else if (storeLocation == "woolwich-greens-end") { storeID = 6475 }
else if (storeLocation == "woolwich-beresford-square") { storeID = 6476 }
else if (storeLocation == "clapham-high-street") { storeID = 6477 }
else if (storeLocation == "rose-hill") { storeID = 6478 }
else if (storeLocation == "longsight") { storeID = 6481 }
else if (storeLocation == "shepherds-bush") { storeID = 6482 }
else if (storeLocation == "cardiff") { storeID = 6483 }
else if (storeLocation == "queens-park") { storeID = 6484 }
else if (storeLocation == "oxford") { storeID = 6485 }
else if (storeLocation == "newcastle-west-road") { storeID = 6486 }
else if (storeLocation == "wood-green") { storeID = 6501 }
else if (storeLocation == "springburn") { storeID = 6503 }
else if (storeLocation == "leicester") { storeID = 6505 }
else if (storeLocation == "luton") { storeID = 6506 }
else if (storeLocation == "walton-vale") { storeID = 6507 }
else if (storeLocation == "corby") { storeID = 6508 }
else if (storeLocation == "irvine") { storeID = 6602 }
else if (storeLocation == "basildon") { storeID = 6603 }
else if (storeLocation == "east-kilbride") { storeID = 6605 }
else if (storeLocation == "rugby") { storeID = 6606 }
else if (storeLocation == "chatham") { storeID = 6607 }
else if (storeLocation == "gravesend") { storeID = 6608 }
else if (storeLocation == "st-helens") { storeID = 6609 }
else if (storeLocation == "watford") { storeID = 6701 }
else if (storeLocation == "wolverhampton") { storeID = 6702 }
else if (storeLocation == "ayr") { storeID = 6703 }
else if (storeLocation == "doncaster") { storeID = 6705 }
else if (storeLocation == "rotherham") { storeID = 6706 }
else if (storeLocation == "sheffield") { storeID = 6707 }
else if (storeLocation == "worksop") { storeID = 6708 }
else if (storeLocation == "portsmouth") { storeID = 6709 }
else if (storeLocation == "cosham") { storeID = 6710 }
else if (storeLocation == "tooting-junction") { storeID = 6711 }
else if (storeLocation == "crawley") { storeID = 6712 }
else if (storeLocation == "birkenhead") { storeID = 6713 }
else if (storeLocation == "ellesmere-port") { storeID = 6714 }
else if (storeLocation == "darlington") { storeID = 6801 }
else if (storeLocation == "wallsend") { storeID = 6802 }
else if (storeLocation == "county-road") { storeID = 6803 }
else if (storeLocation == "leigh") { storeID = 6804 }
else if (storeLocation == "fareham") { storeID = 6805 }
else if (storeLocation == "leith") { storeID = 6806 }
else if (storeLocation == "stockton") { storeID = 6807 }
else if (storeLocation == "wembley") { storeID = 6808 }
else if (storeLocation == "orpington") { storeID = 6809 }
else if (storeLocation == "hyde") { storeID = 6810 }
else if (storeLocation == "rochdale") { storeID = 6811 }
else if (storeLocation == "stirling") { storeID = 6812 }
else if (storeLocation == "sunderland") { storeID = 6813 }
else if (storeLocation == "glasgow-great-western-road") { storeID = 6814 }
else if (storeLocation == "southampton-est") { storeID = 6820 }
else if (storeLocation == "oldham-spindles-shopping-centre") { storeID = 6821 }
else if (storeLocation == "breck-road") { storeID = 6823 }
else if (storeLocation == "west-bromwich-st-michael-street") { storeID = 6824 }
else if (storeLocation == "edinburgh-queen-street") { storeID = 6825 }
else if (storeLocation == "plaistow") { storeID = 6826 }
else if (storeLocation == "birmingham-northfield") { storeID = 6827 }
else if (storeLocation == "chelmsley-wood") { storeID = 6828 }
else if (storeLocation == "chatham-2") { storeID = 6829 }
else if (storeLocation == "plymouth") { storeID = 6830 }
else if (storeLocation == "belle-vale") { storeID = 6831 }
else if (storeLocation == "wester-hailes") { storeID = 6832 }
else if (storeLocation == "cwmbran") { storeID = 6833 }
else if (storeLocation == "pontypridd") { storeID = 6834 }
else if (storeLocation == "sheerness") { storeID = 6835 }
else if (storeLocation == "merthyr-tydfil") { storeID = 6836 }
else if (storeLocation == "kings-lynn") { storeID = 6837 }
else if (storeLocation == "camden") { storeID = 6839 }
else if (storeLocation == "swansea") { storeID = 6840 }
else if (storeLocation == "boston") { storeID = 6841 }
else if (storeLocation == "gloucester") { storeID = 6842 }
else if (storeLocation == "cardiff-canton") { storeID = 6843 }
else if (storeLocation == "islington") { storeID = 6844 }
else if (storeLocation == "warrington") { storeID = 6845 }
else if (storeLocation == "chesterfield") { storeID = 6846 }
else if (storeLocation == "bradford-james-street") { storeID = 6847 }
else if (storeLocation == "bradford-hustlergate") { storeID = 6848 }
else if (storeLocation == "dalston-formally-mybond") { storeID = 6849 }
else if (storeLocation == "green-lanes") { storeID = 6850 }
else if (storeLocation == "feltham") { storeID = 6851 }
else if (storeLocation == "bearwood") { storeID = 6852 }
else if (storeLocation == "hillsborough") { storeID = 6853 }
else if (storeLocation == "beaumont-leys") { storeID = 6854 }
else if (storeLocation == "basingstoke") { storeID = 6855 }
else if (storeLocation == "eastern-avenue") { storeID = 6856 }
else if (storeLocation == "leeds-bramley") { storeID = 6857 }
else if (storeLocation == "leeds-merrion") { storeID = 6858 }
else if (storeLocation == "ipswich-upper-brook-street") { storeID = 6859 }
else if (storeLocation == "felixstowe") { storeID = 6860 }
else if (storeLocation == "dovercourt") { storeID = 6861 }
else if (storeLocation == "luton-bury-park") { storeID = 6862 }
else if (storeLocation == "kingsbury") { storeID = 6863 }
else if (storeLocation == "perry-barr") { storeID = 6864 }
else if (storeLocation == "middleton") { storeID = 6865 }
else if (storeLocation == "eastbourne") { storeID = 6866 }
else if (storeLocation == "worthing") { storeID = 6867 }
else if (storeLocation == "coventry-walsgrave-road") { storeID = 6868 }
else if (storeLocation == "staines") { storeID = 6869 }
else if (storeLocation == "sutton-2") { storeID = 6870 }
else if (storeLocation == "bury") { storeID = 6872 }
else if (storeLocation == "reading") { storeID = 6901 }
else if (storeLocation == "wythenshawe") { storeID = 6902 }
else if (storeLocation == "stoke") { storeID = 6903 }
else if (storeLocation == "leeds") { storeID = 6904 }
else if (storeLocation == "scunthorpe") { storeID = 6905 }
else if (storeLocation == "eltham") { storeID = 6906 }
else if (storeLocation == "derby") { storeID = 6907 }
else if (storeLocation == "gateshead") { storeID = 6908 }
else if (storeLocation == "coventry-lower-precinct") { storeID = 6909 }
else if (storeLocation == "swindon") { storeID = 6910 }
else if (storeLocation == "preston") { storeID = 6911 }
else if (storeLocation == "eastleigh") { storeID = 6913 }
else if (storeLocation == "northampton") { storeID = 6914 }
else if (storeLocation == "harrow-station-road") { storeID = 6915 }
else if (storeLocation == "peterborough") { storeID = 6916 }
else if (storeLocation == "nottingham") { storeID = 6917 }
else if (storeLocation == "colchester") { storeID = 6918 }
else if (storeLocation == "woolwich") { storeID = 6919 }
else if (storeLocation == "southampton") { storeID = 6920 }
else if (storeLocation == "harlow") { storeID = 6921 }
else if (storeLocation == "middlesbrough") { storeID = 6922 }
else if (storeLocation == "edinburgh-nicholson-street") { storeID = 6923 }
else if (storeLocation == "chelmsford") { storeID = 6924 }
else if (storeLocation == "birmingham-soho-road") { storeID = 6925 }
else if (storeLocation == "tottenham") { storeID = 6926 }
else if (storeLocation == "newcastle-grainger-street") { storeID = 6927 }
else if (storeLocation == "glasgow-duke-street") { storeID = 6928 }
else if (storeLocation == "edmonton-south-mall") { storeID = 6929 }
else if (storeLocation == "downham") { storeID = 6930 }
else if (storeLocation == "camberwell") { storeID = 6931 }
else if (storeLocation == "east-ham") { storeID = 6932 }
else if (storeLocation == "grimsby") { storeID = 6934 }
else if (storeLocation == "acton") { storeID = 6935 }
else if (storeLocation == "kilburn") { storeID = 6936 }
else if (storeLocation == "hull") { storeID = 6937 }
else if (storeLocation == "croydon-north-end") { storeID = 6938 }
else if (storeLocation == "west-bromwich-kings-square") { storeID = 6939 }
else if (storeLocation == "romford") { storeID = 6940 }
else if (storeLocation == "lewisham") { storeID = 6942 }
else if (storeLocation == "sutton-in-ashfield") { storeID = 6943 }
else if (storeLocation == "brixton") { storeID = 6944 }
else if (storeLocation == "croydon-east") { storeID = 6945 }
else if (storeLocation == "uxbridge") { storeID = 6946 }
else if (storeLocation == "bexleyheath") { storeID = 6948 }
else if (storeLocation == "birmingham-bull-street") { storeID = 6949 }
else if (storeLocation == "great-bridge") { storeID = 6950 }
else if (storeLocation == "sidcup") { storeID = 6951 }
else if (storeLocation == "hayes") { storeID = 6952 }
else if (storeLocation == "southall") { storeID = 6954 }
else if (storeLocation == "new-addington") { storeID = 6955 }
else if (storeLocation == "kingston") { storeID = 6956 }
else if (storeLocation == "stevenage") { storeID = 6957 }
else if (storeLocation == "bromley") { storeID = 6959 }
else if (storeLocation == "cheetham-hill") { storeID = 6960 }
else if (storeLocation == "harlesden") { storeID = 6961 }
else if (storeLocation == "hackney") { storeID = 6964 }
else if (storeLocation == "sydenham") { storeID = 6965 }
else if (storeLocation == "worcester-park") { storeID = 6966 }
else if (storeLocation == "penge") { storeID = 6967 }
else if (storeLocation == "stratford") { storeID = 6968 }
else if (storeLocation == "bedminster") { storeID = 6969 }
else if (storeLocation == "wolverhampton-queen-street") { storeID = 6973 }
else if (storeLocation == "southend") { storeID = 6974 }
else if (storeLocation == "forest-gate") { storeID = 6977 }
else if (storeLocation == "margate") { storeID = 6980 }
else if (storeLocation == "west-croydon") { storeID = 6982 }
else if (storeLocation == "ilford-high-road") { storeID = 6983 }
else if (storeLocation == "holloway") { storeID = 6984 }
else if (storeLocation == "green-street") { storeID = 6985 }
else if (storeLocation == "crewe") { storeID = 6987 }
else if (storeLocation == "harrow-st-anns-road") { storeID = 6992 }
else if (storeLocation == "walworth-road-2") { storeID = 6993 }
else if (storeLocation == "waterloo") { storeID = 6993 }
else if (storeLocation == "hounslow-central") { storeID = 6995 }
else if (storeLocation == "edmonton-fore-street") { storeID = 6997 }
else if (storeLocation == "bransholme") { storeID = 6875 }
else if (storeLocation == "south-wimbledon") { storeID = 6877 }
else if (storeLocation == "leeds-crossgates") { storeID = 6876 }
else if (storeLocation == "wrexham") { storeID = 6878 }
else if (storeLocation == "bethnal-green") { storeID = 6874 }
else if (storeLocation == "leicester-2") { storeID = 6879 }
else if (storeLocation == "beaconsfield") { storeID = 6880 }


console.log('Store ID: ',storeID)
console.log('Store Location: ',storeLocation)
var allDataPerStore_api = "https://as-handt-store-address-service.azurewebsites.net/api/AllDataPerStore/"+storeID;
var nearestShop_api = "https://as-handt-store-address-service.azurewebsites.net/api/NearestStore";
var map_api = "https://as-handt-store-address-service.azurewebsites.net/api/EmbedMap";

$(document).ready(function(){  
  //bind map
  var mapAjaxSettings = {
    "async": true,
    "crossDomain": true,
    "url": map_api+"/"+storeID,
    "method": "GET"
  }
  $.ajax(mapAjaxSettings).done(function (response) {
    //$('.map-container').html(response)
  });

  //bind store details
  var storeDetailsAjaxSettings = {
    "async": true,
    "crossDomain": true,
    "url": allDataPerStore_api,
    "method": "GET"
  }
  $.ajax(storeDetailsAjaxSettings).done(function (response) {
    $('.store-details-top-info .store-name').text(response.storeName);    
    $('.store-details-top-info .store-direction').attr('href','https://www.google.com/maps/dir/Current+Location/'+response.storeLatitude+','+response.storeLongitude+''); 
    $('.store-details-top-info .store-fulladdress').html('<a target="_blank" href="https://www.google.com/maps/dir/Current+Location/'+response.storeLatitude+','+response.storeLongitude+'">'+response.storeAddress+'<br>'+response.storePostcode+'</a>'); 
    $('.store-details-top-info .store-phonenumber').html("<a href='tel:"+response.storeTelephone1+"'>"+response.storeTelephone1+"</a>");

    //search nearest store    
    nearestShop(response.storePostcode)
    
    //binding timings
    $('#store-timing-details td').each(function(){
      let dayName = $(this).attr('name');
      //console.log(dayName+', '+response[dayName])
      $(this).text(response[dayName]);   
    })
  
    //bind service providers
    /*var servicesArr = [];
    
    for (let index = 0; index < 10; index++) {
      let provider = "serviceProvided"+""+index;
      let providerLabel = response[provider];
      providerLabel = providerLabel.replaceAll(' ','-');
      servicesArr.push(response[provider])
      console.log("servicesArr: ",servicesArr)
    }*/
    
    $('.service-provided-container .serviceProvided').each(function(){
      let provider = $(this).attr('name');
      if(response[provider] != null){
        let responseLabel = response[provider].toLowerCase();
        responseLabel = responseLabel.replaceAll(' ','-');
        let providerLabel = $(this).attr('data-label');
        console.log("label: "+responseLabel+", providerLabel: "+providerLabel)
        if(response[provider] != '' && responseLabel == providerLabel){
          console.log(provider+', '+response[provider])
          //$(this).find('span').text(response[provider]); 
          var pageURL = $(this).attr('data-redirect');
          if(pageURL){
            var storeName = response.storeName
            storeName = storeName.toLowerCase();
            storeName = storeName.replace(' ','-')
            $(this).find('.service-title').html('<a href="'+pageURL+'">'+response[provider]+'</a>');
          }
          else{
            $(this).find('.service-title').text(response[provider]);            
          } 
          $(this).removeClass('hide-item');
        }
      }
    })
  
    //bind paragraphs and Image
    $('#storeImage').attr('src', response.storeImage);
    $('#storeBioParagraph .store-bio').each(function(){
      let paraName = $(this).attr('name');
      //console.log(paraName+', '+response[paraName])
      if(response[paraName] != '' && response[paraName].length > 10){
        $(this).html(response[paraName]); 
        $(this).removeClass('hide-item');
      }else{
        $(this).addClass('hide-item');
      }
    })
    
    //console.log(response);
    //read more/less
    if($('.toggle-read-more').length > 0){
      let dataLen = parseInt($('.toggle-read-more').attr('data-length'));
      let content = $('.toggle-read-more').html();
      let preText = content.substring(0,dataLen);
      //find last closing tag
      dataLen = preText.lastIndexOf('</');
      //update pretext
      preText = content.substring(0,dataLen + 3);
      let postText = content.substring(dataLen + 4, content.length);
      $('.toggle-read-more').html('');
      $('.toggle-read-more').html('<div class="preText">'+preText+'</div><div class="postText" style="display:none;">'+postText+'</div><span class="link_readmore text-red"> Read More</span><span style="display:none;" class="link_readless text-red"> Read Less</span>');
    
      $(document).on('click','.link_readmore', function(){
        $(this).hide();
        $('.link_readless').show();
        $('.postText').show();
      })
      $(document).on('click','.link_readless', function(){
          $(this).hide();
          $('.link_readmore').show();
          $('.postText').hide();
      })
    }

    //binding store location
    storeLocation(response)
  });

  //store details map  
  function storeLocation(response){
    var locations = [
      {
        "storeName": response.storeName,
        "storeLatitude": response.storeLatitude,
        "storeLongitude": response.storeLongitude
      }
    ]
    var grayStyles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5eafa"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "poi",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b19459"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#b19459"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "road.local",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#7e8db2"
            }
          ]
        }
      ]
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 12,
      styles: grayStyles,
      center: new google.maps.LatLng(locations[0].storeLatitude, locations[0].storeLongitude),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });    
    var infowindow = new google.maps.InfoWindow();
    var image = "https://cdn.shopify.com/s/files/1/0592/4592/0393/files/marker.png?v=1703080201";
    var marker, i;    
    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i].storeLatitude, locations[i].storeLongitude),
        map: map,
        icon: image
      });      
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(locations[i].storeName);
          infowindow.open(map, marker);
        }
      })(marker, i));
    }
    //$('#map').css('min-height','50vh');
    //$('#map').css('height','calc(100vh)');
  }
  
  //find neared stores
  function nearestShop(shop_id) {
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": nearestShop_api+'/'+shop_id,
      "method": "GET"
    } 
    $.ajax(settings).done(function (response) {
      if(response.length > 0){      
        $('.stores-count-result').text(response.length);
        bindStoreList(response);   
        storesListSlider();
      }
    });
  }
    
  //bind store list
  function bindStoreList(response){
    let counter = 0;
    $('.results').html('');
    for(var key in response){
      var obj = response[key];
      //console.log(obj.storeName)
      counter++;
      var storeHandle = obj.storeName;
      storeHandle = storeHandle.toLowerCase().trim();
      storeHandle = storeHandle.replaceAll(' ','-').replace("(","").replace(")","").replace(".","");
      let currentStoreName = $('.store-name').text().trim();
      if(currentStoreName != obj.storeName){
      var storeData =
        `<div class="store-list-item grid__item ">
          <div id="Slide-`+storeHandle+`" class="slider__slide card-body body-2" id="`+obj.storeNumber+`">
            <div class="map-marker"><span>`+counter+`</span></div>            
            <div class="store-details" data-store-id="`+obj.storeNumber+`">
              <!--a href="/pages/`+storeHandle+`?id=`+obj.storeNumber+`" title="`+obj.storeName+`" tabindex="0"-->          
              <div class="store-distance store-distance-1">
                <span class="distance-miles">`+obj.distanceFromTarget+`</span>
                <span>Miles</span>
              </div>
              <a href="/pages/`+storeHandle+`" title="`+obj.storeName+`" tabindex="0">
                <div class="store-name" data-latitude="`+obj.storeLatitude+`" data-longitude="`+obj.storeLongitude+`">                  
                  `+obj.storeName+`  
                  <!--span class="text-red view-store-link">View</span-->
                </div>
              </a>
              <address>
                <div class="store-map"><a target="_blank" href="https://www.google.com/maps/dir/Current+Location/`+obj.storeLatitude+','+obj.storeLongitude+`"><i class="fa-light fa-location-dot"></i> `+obj.fullAddress+`</a></div>
                <!--div class="store-hours">Opening Hours: `+obj.monday+`</div-->
                <a href="/pages/`+storeHandle+`" class="learn-more link animate-arrow">Learn More <span class="icon-wrap"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span></a>
              </address>
            </div>
          </div>  
        </div>`; 
      }
      $('#search_stores_result.store-results').append(storeData);
      $('#search_stores_result').show();
    }
  }

  //store list slider
  function storesListSlider(){
    $slick_slider = $("[data-slickslider='storelistitem']");
    settings = {
      centerMode: false,
      infinite: true,
      autoplaySpeed:5000,
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll:3,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      prevArrow:'<i class="slider--arrow PrevArrow fa-thin fa-circle-arrow-left"></i>',
      nextArrow:'<i class="slider--arrow NextArrow fa-thin fa-circle-arrow-right"></i>',
      responsive: [
        {
          breakpoint: 989,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 520,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 375,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ],
    };
    $slick_slider.slick(settings);
  }
  
})

